import { modelOptions, post, prop } from "@typegoose/typegoose";
import { z } from "zod";
import { getZodSchemaFromClass, validate } from "../../../zod-decorator/index.js";
import { addSchemaKeyHook, getDefaultSchemaOptions, SchemaBase, SchemaConstructorArgs } from "../../schemaBase.js";
import { DeviceStatisticsFieldsWithDefaults, DeviceStatisticsSchemaTypes } from "../../types/deviceStatistics.d.js";
import { type DtoValidatorTypes } from "../../validatableClass.js";

const SCHEMA_KEY = "DeviceStatistics" as const;

@modelOptions({ schemaOptions: { ...getDefaultSchemaOptions(SCHEMA_KEY) } })
@post<SchemaBase<DeviceStatistics>>(...addSchemaKeyHook(SCHEMA_KEY))
/**
 * @deprecated - Seed devices only, we should get rid of this ASAP
 */
export class DeviceStatistics extends SchemaBase<DeviceStatistics, DeviceStatisticsFieldsWithDefaults> {
    static readonly schemaKey = SCHEMA_KEY;

    @validate({ schemaKey: SCHEMA_KEY })
    readonly schemaKey = SCHEMA_KEY;

    @validate({ zodValidator: z.number().optional(), responseOnly: true })
    @prop({ type: () => Number, required: true, default: -100 })
    public avgRSSI: number = -100;

    @validate({ zodValidator: z.number().optional(), responseOnly: true })
    @prop({ type: () => Number, required: true, default: 1 })
    public uplinkPacketLossRatio: number = 1;

    @validate({ zodValidator: z.number().optional(), responseOnly: true })
    @prop({ type: () => Number, required: true, default: 1 })
    public downlinkPacketLossRatio: number = 1;

    @validate({ zodValidator: z.number().optional(), responseOnly: true })
    @prop({ type: () => Number, required: true, default: 1 })
    public errorRatio: number = 1;

    @validate({ zodValidator: z.number().optional(), responseOnly: true })
    @prop({ type: () => Number, required: true, default: 1 })
    public packetLossRatio: number = 1;

    static getters = {} as const satisfies Record<string, (self: DeviceStatistics) => any>;

    static utilities = {} as const satisfies Record<string, (...args: any) => any>;

    static dtoValidators: DtoValidatorTypes<DeviceStatisticsSchemaTypes>;

    constructor(properties?: SchemaConstructorArgs<DeviceStatistics, DeviceStatisticsFieldsWithDefaults>) {
        super(properties);
        Object.assign(this, properties);
    }
}

DeviceStatistics.dtoValidators = getZodSchemaFromClass(
    DeviceStatistics,
) as unknown as DtoValidatorTypes<DeviceStatisticsSchemaTypes>;
